export default {
  name: 'Denmark',
  phonePattern: '20123456',
  postalCodePattern: '1111',
  singlePostalCode: '',
  postalCodeRegex: '',
  language: '',
  dobFormat: 'DD.MM.YY',
  currency: 'dkk'
}



// WEBPACK FOOTER //
// ./src/locales/countries/DK.js